export const COMMON_RESPONSE_ERROR_TITLE = 'components.response-errors.common_response_error_title';
export const COMMON_UNKNOWN_ERROR_TITLE = 'components.response-errors.common_unknown_error_title';
